export enum OwnSensorOption {
  DexcomStelo = 'Dexcom Stelo',
  DexcomG7 = 'Dexcom G7 / Dexcom G7 15 Day',
  DexcomG6 = 'Dexcom G6',
  Lingo = 'Lingo',
  FreeStyleLibre3 = 'FreeStyle Libre 3 / FreeStyle Libre 3 Plus',
  FreeStyleLibre2 = 'FreeStyle Libre 2',
  FreeStyleLibre14Day = 'FreeStyle Libre 14-Day System',
  Other = 'Other',
}

export enum OwnSensorSurveyAnswer {
  DexcomStelo = 'dexcom_stelo',
  DexcomG6 = 'dexcom_g6',
  DexcomG7 = 'dexcom_g7',
  Lingo = 'lingo',
  Libre1 = 'libre1',
  Libre2 = 'libre2',
  Libre3 = 'libre3',
  Other = 'other',
}

export const OwnSensorSurveyAnswers: Record<OwnSensorOption, OwnSensorSurveyAnswer> = {
  [OwnSensorOption.DexcomStelo]: OwnSensorSurveyAnswer.DexcomStelo,
  [OwnSensorOption.DexcomG6]: OwnSensorSurveyAnswer.DexcomG6,
  [OwnSensorOption.DexcomG7]: OwnSensorSurveyAnswer.DexcomG7,
  [OwnSensorOption.Lingo]: OwnSensorSurveyAnswer.Lingo,
  [OwnSensorOption.FreeStyleLibre14Day]: OwnSensorSurveyAnswer.Libre1,
  [OwnSensorOption.FreeStyleLibre2]: OwnSensorSurveyAnswer.Libre2,
  [OwnSensorOption.FreeStyleLibre3]: OwnSensorSurveyAnswer.Libre3,
  [OwnSensorOption.Other]: OwnSensorSurveyAnswer.Other,
}

export enum OwnSensorInfoText {
  OtherSensor = "We are working on supporting this sensor and will let you know when it's available.",
  Lingo = 'There is a 3-hour delay between Lingo and Nutrisense. Tap to learn more.',
}
